import React from "react";
import { Container, Row, Col, ListGroup, ListGroupItem } from "reactstrap";

import "./footer.css";

const footerQuickLinks = [
  {
    display: "Uy",
    url: "#",
  },
  {
    display: "Haqida",
    url: "#",
  },

  {
    display: "Bo'limlar",
    url: "#",
  },

  {
    display: "Bloglar",
    url: "#",
  },
];

const footerInfoLinks = [
  {
    display: "Privacy Policy",
    url: "#",
  },
  {
    display: "Membership",
    url: "#",
  },

  {
    display: "Purchases Guide",
    url: "#",
  },

  {
    display: "Terms of Service",
    url: "#",
  },
];

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row>
          <Col lg="3" md="6" className="mb-4">
            <h4 className=" d-flex align-items-center gap-1">
              <i class="ri-pantone-line"></i> Polimerlarni qayta ishlash texnologiyasi.
            </h4>

            <div className="follows">
              <p className="mb-0">Bizni ijtimoiy tarmoqlarda kuzatib boring</p>
              <span>
                {" "}
                <a href="https://www.facebook.com/1yucuf26">
                  <i class="ri-facebook-line"></i>
                </a>
              </span>

              <span>
                {" "}
                <a href="https://www.instagram.com/theyucuf/">
                  <i class="ri-instagram-line"></i>
                </a>
              </span>

              <span>
                {" "}
                <a href="https://www.linkedin.com/in/azamat-mavlonov-26b877237/">
                  <i class="ri-linkedin-line"></i>
                </a>
              </span>

              <span>
                {" "}
                <a href="https://t.me/shakhzodj">
                  <i class="ri-twitter-line"></i>
                </a>
              </span>
            </div>
          </Col>

          <Col lg="3" md="6" className="mb-4">
            <h6 className="fw-bold">Tadqiq qiling</h6>
            <ListGroup className="link__list">
              {footerQuickLinks.map((item, index) => (
                <ListGroupItem key={index} className="border-0 ps-0 link__item">
                  {" "}
                  <a href={item.url}>{item.display}</a>
                </ListGroupItem>
              ))}
            </ListGroup>
          </Col>

          <Col lg="3" md="6" className="mb-4">
            <h6 className="fw-bold">Information</h6>
            <ListGroup className="link__list">
              {footerInfoLinks.map((item, index) => (
                <ListGroupItem key={index} className="border-0 ps-0 link__item">
                  {" "}
                  <a href={item.url}>{item.display}</a>
                </ListGroupItem>
              ))}
            </ListGroup>
          </Col>

          <Col lg="3" md="6">
            <h6 className="fw-bold">Biz bilan bog'lanish</h6>

            <p>Manzil: Uzbekistan Qarshi</p>
            <p> Telefon raqami: +99891452666 </p>
            <p>Email: t_shahzod@mail.ru</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
